import React from 'react';
import ServerPaginatedTable from '../utils/pagination.server';
import ToolTipItem from "../utils/tooltip";
import PageEmptyContent from "../utils/page.empty-content";
import EditIcon from 'react-icons/lib/md/edit';


const DataTable = ({data, handleEdit, pageIndex }) =>{
    return (data.length === 0) ?
        (<PageEmptyContent message='No record match your search!'/>) :
        (
            <div className="view">
                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead>
                        <tr>
                            <th>
                                <span>S/N</span>
                            </th>
                            <th>
                                <span>Airline</span>
                            </th>
                            <th >
                                <span>Ticket Class</span>
                            </th>
                            <th >
                                <span>Category</span>
                            </th>
                            <th >
                                <span>Edit</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.map((record, i) =>
                            <tr key={i}>
                                <td className="text-capitalize">{ `${pageIndex + i + 1}`  }</td>
                                <td
                                    className="text-capitalize">{record.AirlineName}</td>
                                <td>{record.TicketName}</td>
                                <td>{record.CategoryName}</td>
                                <td>
                                    <span className="pointer" onClick={() => handleEdit(record)}>
                                        <ToolTipItem key={'Edit Record'} title={<EditIcon size="18" color="#3da7e2"/>} content='View' id={'viewRecord'}/>
                                    </span>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
};

class PaginatedResult extends React.Component {

    render() {
        const {  pageSize, currentPage, totalCount,navigate, records, handleEdit} = this.props;
        let pageIndex = (currentPage - 1) * pageSize;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 mb-4" >
                        <ServerPaginatedTable  currentPage={currentPage} fetchMore={navigate}
                                               target={<DataTable data={records} handleEdit={handleEdit} pageIndex={pageIndex}/>}
                                               pageSize={pageSize} totalCount={totalCount}

                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default PaginatedResult



// WEBPACK FOOTER //
// ./src/views/ticket-class-setup/record.js